import React from "react";
import { FamilyResponsabilityIcon, FamilyVisibilityIcon, FamilyPaymentsIcon, FamilyControlIcon } from "../../../assets/icons";
import styles from "./shared-account.module.scss";

interface Props {
	onSkip: () => void;
	onSetUp: () => void;
}

const FEATURES = [
	{
		icon: <FamilyResponsabilityIcon />,
		title: "Share Responsibility",
		desc: "Let others help manage your account.",
	},
	{
		icon: <FamilyVisibilityIcon />,
		title: "Shared Visibility",
		desc: "Give members access to view usage and transactions.",
	},
	{
		icon: <FamilyPaymentsIcon />,
		title: "Share payments",
		desc: "Let members buy units and pay bills.",
	},
	{
		icon: <FamilyControlIcon />,
		title: "You stay in control",
		desc: "Decide who joins and what they can do.",
	},
];

export const SharedAccountWelcomePage: React.FC<Props> = ({ onSkip, onSetUp }) => {
	return (
		<div className={styles.stepContent}>
			<img src="/images/shared_account_info.gif" alt="" className={styles.welcomeGif} />

			<div className={styles.featureList}>
				{FEATURES.map(({ icon, title, desc }) => (
					<div key={title} className={styles.featureItem}>
						<div className={styles.featureIconWrapper}>{icon}</div>
						<div className={styles.featureTextGroup}>
							<span className={styles.featureTitle}>{title}</span>
							<span className={styles.featureDesc}>{desc}</span>
						</div>
					</div>
				))}
			</div>
			 <div className={styles.buttonSection}>
				
			<button className={styles.continueButton} onClick={onSetUp}>
				Set Up Shared Account
			</button>
			<button className={styles.skipButton} onClick={onSkip}>
				Skip for now
			</button>
			 </div>
		</div>
	);
};
